export default {
      id: "uspCard-critical-illness-usage",
      viewBox: "0 0 200 60",
      url: __webpack_public_path__ + "sprite.svg#uspCard-critical-illness",
      toString: function () {
        return this.url;
      }
    }